import { render } from "./commonTabbar.vue?vue&type=template&id=189e37b0&scoped=true"
import script from "./commonTabbar.vue?vue&type=script&lang=js"
export * from "./commonTabbar.vue?vue&type=script&lang=js"

import "./commonTabbar.vue?vue&type=style&index=0&id=189e37b0&lang=less&scoped=true"

import exportComponent from "D:\\company\\jifen\\AccumulatedPointsStore\\src\\SPA\\AccumulatedPointsStore.ApiEndpoint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189e37b0"]])

export default __exports__